import { render, staticRenderFns } from "./ModalCartDetail.vue?vue&type=template&id=35bf670e&scoped=true&"
import script from "./ModalCartDetail.vue?vue&type=script&lang=js&"
export * from "./ModalCartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalCartDetail.vue?vue&type=style&index=0&id=35bf670e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf670e",
  null
  
)

export default component.exports